module.exports = __webpack_public_path__ + "static/media/honda_logo.1443202d.svg";